import { getTopArticles } from "@/graphql/schemas/shared/utils/getArticles"
import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"
import { AppSettings } from "@/settings"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryCustomerTopArticles = {
  async customerTopArticles(parent, args, context, info) {
    const { customerNumber, page, size, sort, year, lang = AppSettings.defaultLocale(), cdn = true } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ARTICLES,
      operation: Operations.READ,
    })

    await validateAccessRightsToCustomer({ user, customerNumber })

    const sortString = EinzaGraphiQLService.formatSortParam(sort)

    const graphiQLQueryObject = [
      {
        method: "customerStatsByArticle",
        variables: { customerNumber, page, size, ...(sortString && { sort: sortString }), year },
        fields: ["number", "numberOfElements", "totalElements", "totalPages"],
        expandedFields: {
          content: ["year", "customerNumber", "sku", "revenue", "quantity", "margin", "amount"],
        },
      },
    ]

    const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
    const einzaResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.customerStatsByArticle

    if (!einzaResponse?.content) {
      throw new Error("Data could not be retrieved")
    }

    if (einzaResponse?.content?.length <= 0) {
      return {
        total: einzaResponse.totalElements,
        items: [],
        page,
        size,
        sort,
        totalPages: einzaResponse.totalPages,
      }
    }

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const statsByArticle = await getTopArticles(einzaResponse?.content, client)

    return {
      total: einzaResponse.totalElements,
      items: statsByArticle,
      page,
      size,
      sort,
      totalPages: einzaResponse.totalPages,
    }
  },
}
